import React, { createContext } from 'react';

export interface IResourceModalHandlerSettings {
  shareLink?: string;
}

export interface ResourceModalHandlerInfo {
  settings: IResourceModalHandlerSettings;
}

export const ResourceModalHandlerContext = createContext<ResourceModalHandlerInfo>({
  settings: {
    shareLink: null,
  },
});
